/**
 * Simple BroadcastChannel for Dialog Communication
 */
let channel = null;
/**
 * Khởi tạo channel
 */
export function initBroadcast(onMessage) {
    if (channel)
        channel.close();
    channel = new BroadcastChannel('dialog-data');
    if (onMessage) {
        channel.onmessage = (event) => onMessage(event.data);
    }
    return channel;
}
/**
 * Gửi data
 */
export function sendData(data) {
    if (!channel) {
        console.warn('Channel not initialized');
        return false;
    }
    channel.postMessage(data);
    return true;
}
/**
 * Đóng channel
 */
export function closeBroadcast() {
    if (channel) {
        channel.close();
        channel = null;
    }
}
/**
 * Usage:
 *
 * // Trong component:
 * initBroadcast((data) => console.log('Received:', data));
 * sendData({ type: 'form', payload: formData });
 *
 * // Trong dialog:
 * initBroadcast((data) => {
 *   if (data.type === 'form') {
 *     populateForm(data.payload);
 *   }
 * });
 * sendData({ type: 'submit', payload: result });
 */ 
